import {
	makeStyles,
	Caption1Stronger,
	Card,
	CardFooter,
	CardHeader,
	CardPreview,
	tokens
} from '@fluentui/react-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { StarRegular, StarFilled, StarHalfFilled } from '@fluentui/react-icons';
import { Platform } from '../Media/Types';
import BoxArt from '../Shared/BoxArt';
import { useNavigate } from 'react-router';
import { VideoGameListItem } from '../Api/Games/types';

export interface GameItemProps {
	game: VideoGameListItem;
}

const GameItem = (props: GameItemProps) => {
	const styles = useStyles();
	const navigator = useNavigate();

	const AverageRating = () => {
		const { averageRating } = props.game;
		const totalStars = 5;
		let fullStars = 0;
		let halfStars = 0;

		if (averageRating) {
			fullStars = Math.floor(averageRating / 2);
			halfStars = Math.floor(averageRating % 2);
		}

		const emptyStars = totalStars - (fullStars + halfStars);

		return (
			<div
				title={`Average Rating: ${
					averageRating ? String(averageRating) : 'N/A'
				}`}
				style={{ display: 'flex' }}
			>
				{Array.from(Array(fullStars)).map((index) => (
					<StarFilled key={`star-filled-${String(index)}`} />
				))}
				{Array.from(Array(halfStars)).map((index) => (
					<StarHalfFilled key={`star-half-filled-${String(index)}`} />
				))}
				{Array.from(Array(emptyStars)).map((index) => (
					<StarRegular key={`star-${String(index)}`} />
				))}
			</div>
		);
	};

	return (
		<Card
			className={styles.root}
			onClick={() => navigator(`/Games/${String(props.game.id)}`)}
		>
			<CardHeader
				image={null}
				header={
					<div
						style={{
							display: 'flex',
							justifyContent: 'space-between',
							overflow: 'hidden',
							height: '20px',
							width: '100%'
						}}
					>
						<Caption1Stronger title={props.game.title}>
							{props.game.title}
						</Caption1Stronger>
						<AverageRating />
					</div>
				}
			></CardHeader>

			<CardPreview
				logo={
					<div
						className={styles.platformIcon}
						title='Total Reviews'
					>
						<b>{props.game.totalReviews ?? 0}</b>
					</div>
				}
			>
				<BoxArt
					imageSrc={props.game.boxArtUrl}
					altText={props.game.title}
					thumbnail
				/>
			</CardPreview>

			<CardFooter
				style={{ display: 'flex', justifyContent: 'space-between' }}
			>
				<div className={styles.platformList}>
					{props.game.availableOnConsoles.map((item) => (
						<div
							key={`${props.game.title.replaceAll(
								' ',
								''
							)}-${item.name.replaceAll(' ', '')}`}
						>
							<FontAwesomeIcon
								icon={new Platform(item.name).FaIconName}
								title={item.name}
							/>
						</div>
					))}
				</div>
			</CardFooter>
		</Card>
	);
};

export default GameItem;

const useStyles = makeStyles({
	root: {
		minWidth: '225px',
		maxWidth: '250px',
		width: '250px',
		':hover': {
			cursor: 'pointer',
			backgroundColor: tokens.colorBrandBackgroundHover
		}
	},
	platformList: {
		display: 'flex',
		columnGap: '4px',
		overflowX: 'hidden'
	},
	platformIcon: {
		backgroundColor: tokens.colorNeutralForeground1,
		width: '35px',
		borderRadius: '12px',
		border: `1px solid ${tokens.colorNeutralBackground1}`,
		textAlign: 'center',
		color: tokens.colorBrandBackground
	}
});
